import { Stack } from '@mui/material';
import { CandidateNavbarUserDropdownMenu } from '../../../UserNavigationMenus/CandidateMenus/CandidateNavbarUserDropdownMenu';
import { CandidateNavBarAuthenticatedViewProps } from 'types/connectTypes';
import { JobSeekingStatusDropdown } from 'components/JobSeekingStatus/JobSeekingStatusDropdown';
import { useRouteMatch } from 'react-router-dom';
import { connectRedirectUrls } from 'utils/constants/connect';

// TODO: uncomment in final PR in-app match quiz access goes live
// import { MatchQuizButton } from 'components/NavBar/NavBarButtons/MatchQuizButton';
export const CandidateNavBarAuthenticatedView: React.FC<CandidateNavBarAuthenticatedViewProps> = ({
  user,
  candidateMatches,
  isOnConnect,
  isCandidatePortal,
}) => {
  const isConnectProfilePage = useRouteMatch({ path: connectRedirectUrls.PROFILE, exact: true });
  const isConnectQualificationsPage = useRouteMatch({
    path: connectRedirectUrls.QUALIFICATIONS,
    exact: true,
  });
  const isConnectPreferencesPage = useRouteMatch({
    path: connectRedirectUrls.PREFERENCES,
    exact: true,
  });

  const isConnectOnboardingFlowPage =
    isConnectProfilePage || isConnectQualificationsPage || isConnectPreferencesPage;

  return (
    <Stack direction={'row'} gap={1} alignItems="center">
      {/* 
      TODO: uncomment in final PR in-app match quiz access goes live
      <MatchQuizButton user={user} /> 
      */}
      {(isOnConnect || isCandidatePortal) && !isConnectOnboardingFlowPage && (
        <JobSeekingStatusDropdown
          userId={user.id}
          userJobSeekingStatus={user.preference?.job_seeking_status}
          width={{ xs: '180px', sm: '220px' }}
          autoSave
        />
      )}
      <CandidateNavbarUserDropdownMenu user={user} candidateMatches={candidateMatches} />
    </Stack>
  );
};
